import { FC } from 'react'
import { ActionType } from '../../util/util'
import { ListItemType } from '../ListItem'

export interface ListData {
  id: string
  value?: string
  title?: string
  url?: string
  styledText?: string
  date?: string
  file?: string
  totalAmount?: string
  transactionStatus?: string
  totalRefund?: string
  refundCount?: string
  chargebackAmount?: string
  chargebackCount?: string
  settlementAmount?: string
  utrNo?: string
  iconId?: any
  navigateTo?: string
  merRefNo?: string
  jioMoneyRef?: string
  bankRefNo?: string
  dateTime?: string
  Amount?: string
  totalCount?: string
  Status?: string
  paymentMode?: string
  Scheme?: string
  Bank?: string
  Action?: string
  [key: string]: any
  isRead?: boolean
  startDateTime?: string
  accountOne?: string
  accountNumber?: string
  tokenPan?: string
  refundAmount?: number
  acquirerBusiness?: string
  acquirerInstitution?: string
  acquirerTerminal?: string
  actionCode?: string
  additionalDataNational?: string
  authCode?: string
  clerk?: string
  extendedData?: string
  financialType?: string
  issuerInstitution?: string
  merchantCity?: string
  merchantName?: string
  merchantType?: string
  merchantId?: string
  retrievalReferenceNumber?: string
  surCharge?: string
  systemTraceAuditNumber?: string
  transactionAmount?: string
  transactionClass?: string
  transactionDateTime?: string
  transactionDisposition?: string
  transactionType?: string
  accountNoSufix?: string
  accountNoPrefix?: string
  forwardingId?: string
  acqDate?: string
  acqCountryCode?: string
  acqDateConver?: string
  acqMsgResonCode?: string
  addDataAcq?: string
  addDataIssuer?: string
  availableBal?: string
  issCountryCode?: string
  issDateConv?: string
  cardLogoId?: string
  cardType?: string
  cardAcceptTer?: string
  cardAcceptId?: string
  conFee?: string
  funcCode?: string
  emiInd?: string
  issRefData?: string
  action?: string
  refundData?: RefundDataType[]
  pendingAmount?: string
  settlementDate?: string
  settlementFilename?: string
  paymentModeNumber?: string
}

export interface RefundDataType {
  rrn?: string
  transactionAmount: string
  refundAmount: string
  refundInitiatedDate: string
  refundStatus: string
  refundDate: string
}

export interface ListProps {
  type?: ListItemType
  data: ListData[] | any
  onPress?: (data: ListData, index?: number | undefined) => void
  header?: FC
  footer?: FC
  emptyComponent?: React.ReactElement | FC
  selectedPos?: number
  transactionType?: number
  hide?: boolean
  selectedItems?: number[]
  onItemAction?: (actionType: ActionType, id: string) => void
  onChangeInput?: (rrn: string, value: string) => void
  extendedColumns?: string[]
  disableItem?: boolean
  from?: string
  freezeColumn?: string
  onDownloadFileAction?: (fileType: string, id: string) => void
  onDeleteReportFile?: (data: any) => void
  onDownloadReportFile?: (data: any) => void
  isStickyHeader?: boolean
  showHideSubMenu?: (showHide: boolean, parentId: string) => void
  onEditReport?: (data: any) => void
  onLayout?: any
  onContentSizeChange?: (width: any, height: any) => void
  flatListRef?: any
  onScroll?: any
}

export enum COMPONENT {
  TABLE = 'TABLE',
  LIST = 'LIST',
}
